import http from "./httpService";
import config from "config.json";
const { apiUrl } = config;
//Region
const getRegion = async (query) => {
  const url = `${apiUrl}/sales-region/get-region-list${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const addUpdateRegion = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/save-region`;
    const data = await http.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
const deleteRegion = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/delete-region/${values}`;
    const data = await http.delete(url);
    return data;
  } catch (error) {
    throw error;
  }
};
//Area
const getArea = async (query) => {
  const url = `${apiUrl}/sales-region/get-area-list${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const addUpdateArea = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/save-area`;
    const data = await http.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
const deleteArea = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/delete-area/${values}`;
    const data = await http.delete(url);
    return data;
  } catch (error) {
    throw error;
  }
};
///autocomplete
const getRegionAutoComplete = async (values) => {
  const url = `${apiUrl}/sales-region/region-dropdown/search?search=${values}`;
  const data = await http.get(url);
  return data;
};
const getRegionalManagerAutoComplete = async (values) => {
  const url = `${apiUrl}/sales-region/regional-sales-manager-dropdown/search?search=${values}`;
  const data = await http.get(url);
  return data;
};
const getSalesManagerAutoComplete = async (values) => {
  const url = `${apiUrl}/sales-region/sales-manager-dropdown/search?search=${values}`;
  const data = await http.get(url);
  return data;
};
const getAreaAutoComplete = async (values) => {
  const url = `${apiUrl}/sales-region/area-dropdown/search?search=${values}`;
  const data = await http.get(url);
  return data;
};
const getAreaSalesManagerAutoComplete = async (values) => {
  const url = `${apiUrl}/sales-region/area-sales-manager-dropdown/search?search=${values}`;
  const { data: data } = await http.get(url);
  return data;
};
const getSeniorExecutiveAutoComplete = async (values) => {
  const url = `${apiUrl}/sales-region/senior-sales-executive-dropdown/search?search=${values}`;
  const { data: data } = await http.get(url);
  return data;
};
const getSalesPersonAutoComplete = async (query) => {
  try {
    const url = `${apiUrl}/sales-region/sales-executive/search${
      query ? `?${query}` : ""
    }`;

    const { data } = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
//Regional Manager
const getRegionalManager = async (query) => {
  const url = `${apiUrl}/authenticate/sales-users${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const addUpdateRegionalManager = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/add-regional-sales-manager`;
    const data = await http.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
const deleteRegionalManager = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/delete-area/${values}`;
    const data = await http.delete(url);
    return data;
  } catch (error) {
    throw error;
  }
};
//Sales Manager
const getSalesManager = async (query) => {
  const url = `${apiUrl}/authenticate/sales-users${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const addUpdateSalesManager = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/add-sales-manager`;
    const data = await http.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
const deleteSalesManager = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/delete-area/${values}`;
    const data = await http.delete(url);
    return data;
  } catch (error) {
    throw error;
  }
};
//Area Sales Manager
const getAreaSalesManager = async (query) => {
  const url = `${apiUrl}/authenticate/sales-users${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const addUpdateAreaSalesManager = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/add-area-sales-manager`;
    const data = await http.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
const deleteAreaSalesManager = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/delete-area/${values}`;
    const data = await http.delete(url);
    return data;
  } catch (error) {
    throw error;
  }
};
//Senior Executive
const getSeniorExecutive = async (query) => {
  const url = `${apiUrl}/authenticate/sales-users${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const addUpdateSeniorExecutive = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/add-senior-sales-executive`;
    const data = await http.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
//Sales Person
const getSalesPerson = async (query) => {
  const url = `${apiUrl}/authenticate/sales-users${query ? `?${query}` : ""}`;
  const data = await http.get(url);
  return data;
};
const addUpdateSalesPerson = async (values) => {
  try {
    const url = `${apiUrl}/sales-region/add-sales-executive`;
    const data = await http.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
export {
  getSeniorExecutiveAutoComplete,
  getSalesPerson,
  addUpdateSalesPerson,
  getSeniorExecutive,
  addUpdateSeniorExecutive,
  getAreaSalesManagerAutoComplete,
  getAreaAutoComplete,
  getSalesManagerAutoComplete,
  getAreaSalesManager,
  addUpdateAreaSalesManager,
  deleteAreaSalesManager,
  getSalesManager,
  addUpdateSalesManager,
  deleteSalesManager,
  getRegion,
  addUpdateRegion,
  deleteRegion,
  getArea,
  addUpdateArea,
  deleteArea,
  getRegionAutoComplete,
  getRegionalManager,
  addUpdateRegionalManager,
  deleteRegionalManager,
  getRegionalManagerAutoComplete,
  getSalesPersonAutoComplete,
};
